// extracted by mini-css-extract-plugin
module.exports = {"plus":"plus__OIeCZ","entrance-fee":"entrance-fee__3-WOZ","label":"label__26AKZ","price":"price__19f25","price-no":"price-no__1489B"};